import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Select2OptionData } from 'ng2-select2/ng2-select2.interface';
import { SessionService } from '../../../shared/services/session.service';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user.model';
import { TipoConsulta } from '../../../shared/enumeration/tipo-consulta.enum';
import { ListService } from '../../../shared/services/list.service';

import { ToastrService } from 'ngx-toastr';

import swal from 'sweetalert2';
import { IpssService } from '../../../shared/services/ipss.service';
import { ExamenService } from '../../../shared/services/examen.service';
import { VoucherAttachedService } from '../../../shared/services/voucher-attached.service';
import { IconoUtility } from '../../../shared/utilities/icono.utility';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { ExamenPlanIps } from '../../../shared/models/examen-plan-ips.model';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { ApiConfig } from '../../../shared/services/config/api.config';
import { BeneficiaryService } from '../../../shared/services/beneficiary.service';
import { Beneficiary } from '../../../shared/models/beneficiary.model';

declare var jQuery: any;

@Component({
  selector: 'app-request-authorization',
  templateUrl: './request-authorization.component.html',
  styleUrls: ['./request-authorization.component.css']
})
export class RequestAuthorizationComponent implements OnInit {

  public beneficiarios: Select2OptionData[];

  public selectedBeneficiario: string;

  public ciudades: Select2OptionData[];

  public ciudadSeleccionada: string;

  public ciudadSeleccionadaTexto: string;

  public autorizacionesAutomaticas: Select2OptionData[];

  public autorizacionAutomaticaSeleccionada: string;

  public autorizacionAutomaticaSeleccionadaTexto: string;

  public ipss: Select2OptionData[];

  public ipssSeleccionada: string;

  public ipssSeleccionadaTexto: string;

  public bilateridad: Select2OptionData[];

  public bilateridadSeleccionada: string;

  public clasificarSolicitud: Select2OptionData[];

  public clasificarSolicitudSeleccionada: string;

  public clasificarSolicitudSeleccionadaTexto: string;

  public contratoSeleccionado: string;

  identificacionSolicitante: string;

  plan: string;

  usuarioSolicitante: User;

  beneficiariosContrato: Array<User>;

  showSpinnerAutorizacionesAutomaticas: boolean;

  showSpinnerBeneficiarios: boolean;

  showSpinnerManual: boolean;

  showSpinnerAutomatico: boolean;

  showSpinnerCiudades: boolean;

  showSpinnerIpss: boolean;

  showSpinnerExamenPlanIps: boolean;

  examenPlanIps: ExamenPlanIps[];

  showSpinnerClasificarSolicitud: boolean;

  citasDisponibles30Dias: boolean;

  valueAutorizacionAutomatica: string;

  files: any;

  obsClasificarSolicitud: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private _sessionService: SessionService,
    private _userService: UserService,
    private _listService: ListService,
    private _ipssService: IpssService,
    private _examenService: ExamenService,
    private _voucherAttached: VoucherAttachedService,
    private _appointmentService: AppointmentService,
    private _authorizationService: AuthorizationService,
    private _apiConfig: ApiConfig,
    private _beneficiaryService: BeneficiaryService
  ) { }

  ngOnInit() {
    this.selectedBeneficiario = '';
    this.identificacionSolicitante = '';
    this.ciudadSeleccionada = '';
    this.ciudadSeleccionadaTexto = '';
    this.autorizacionAutomaticaSeleccionada = '';
    this.autorizacionAutomaticaSeleccionadaTexto = '';
    this.bilateridadSeleccionada = '';
    this.ipssSeleccionada = '';
    this.ipssSeleccionadaTexto = '';
    this.clasificarSolicitudSeleccionada = '';
    this.clasificarSolicitudSeleccionadaTexto = '';
    this.obsClasificarSolicitud = '';
    this.showSpinnerAutorizacionesAutomaticas = false;
    this.showSpinnerBeneficiarios = false;
    this.showSpinnerManual = false;
    this.showSpinnerAutomatico = false;
    this.showSpinnerCiudades = false;
    this.showSpinnerIpss = false;
    this.showSpinnerExamenPlanIps = false;
    this.showSpinnerClasificarSolicitud = false;
    this.citasDisponibles30Dias = false;
    this.plan = '';

    let _contractSelect = this._sessionService.getSelectContract();

    this.contratoSeleccionado = _contractSelect;

    this.showSpinnerBeneficiarios = true;

    //this._beneficiaryService.getBeneficiariesMedical(_contractSelect, this._sessionService.getCurrentUser().documentId,
    //this._sessionService.getSelectDocumentTypeContracted()).subscribe(
    this._beneficiaryService.getBeneficiariesContract(_contractSelect, this._sessionService.getCurrentUser().documentId,
      this._sessionService.getSelectDocumentTypeContracted()).subscribe(
      res => {

        let _res: any[];

        //Usuario menor de edad
        if (this._sessionService.getCurrentUser().age < 18) {
          let i: number;
          i = 0;
          for (let usuario of res) {
            if (usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId) {
              _res = this.toSelect2(Array<Beneficiary>(res[i]));
            }
            i++;
          }
        }
        else {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            if (usuario.estado === 'ACTIVO') {
              _array.push(usuario);
            }
            j++;
          }

          _res = this.toSelect2(_array);
        }
        /*else {

          if(this._sessionService.getCurrentUser().actualizacionMenu){
            //Usuario contratante
            let j : number;
            j = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                j++;
            }

            _res = this.toSelect2(_array);
          }
          else {
            //Usuario beneficiario mayor de edad
            let k : number;
            k = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                k++;
            }

            _res = this.toSelect2(_array);
          }
        }*/

        let _optionDefault = this.getOptionDefault('Seleccione un solicitante...');
        let _optionBeneficiarios = _res;
        let _options = _optionDefault.concat(_optionBeneficiarios);
        this.showSpinnerBeneficiarios = false;
        this.beneficiarios = _options;
      },
      err => {
        this.showSpinnerBeneficiarios = false;
        console.log(err);
      }
      )

    this.showSpinnerCiudades = true;
    this._listService.getList({ tipoConsulta: TipoConsulta.CiudadesProcedimiento }).subscribe(
      res => {

        let _optionDefault = this.getOptionDefault('Seleccione una ciudad...');
        let _optionCiudades = res;
        let _options = _optionDefault.concat(_optionCiudades);
        this.showSpinnerCiudades = false;
        this.ciudades = _options;
      },
      err => {
        this.showSpinnerCiudades = false;
        console.log(err);
      }
    )
    this.showSpinnerAutorizacionesAutomaticas = true;
    this._listService.getList({ tipoConsulta: TipoConsulta.AutorizacionesAutomaticas }).subscribe(
      res => {
        //console.log(res);
        this.showSpinnerAutorizacionesAutomaticas = false;
        let _optionDefault = this.getOptionDefault('Seleccione una opción...');
        let _optionAutorizaciones = res;
        let _options = _optionDefault.concat(_optionAutorizaciones);
        this.autorizacionesAutomaticas = _options;

      },
      err => {
        this.showSpinnerAutorizacionesAutomaticas = false;
        console.log(err);
      }
    )

    //beneficiarios contrato
    this._userService.getAfiliados(this.contratoSeleccionado, '-', 2, this._sessionService.getCurrentUser().documentId,
      this._sessionService.getSelectDocumentTypeContracted()).subscribe(
      res => {
        this.beneficiariosContrato = res;
      },
      err => {
        console.log(err);
      }
      )

    //consulta bilateridad
    this._examenService.getBilateridad().subscribe(
      res => {

        let _optionDefault = this.getOptionDefault('Seleccione una opción...');
        let _optionBilateridad = res;
        let _options = _optionDefault.concat(_optionBilateridad);
        this.bilateridad = _options;

      },
      err => {
        console.log(err);
      }
    )
  }

  toSelect2(source: Beneficiary[]): any[] {

    var _array = [];

    for (let s of source) {
      let _obj = {
        id: s.documentoIdentidad,
        text: s.documentoIdentidad + ' - ' + s.nombre
      };
      _array.push(_obj);
    }

    return _array;
  }

  getOptionDefault(texto: string): any[] {
    return [{ id: '-1', text: texto }];
  }

  public changed(e: any): void {
    this.selectedBeneficiario = e.value;
    this.identificacionSolicitante = '';

    if (this.selectedBeneficiario !== '-1' && this.selectedBeneficiario !== '') {
      this.identificacionSolicitante = this.selectedBeneficiario;

      this._userService.getAfiliados(this.identificacionSolicitante, this.contratoSeleccionado, 1, this._sessionService.getCurrentUser().documentId,
        this._sessionService.getSelectDocumentTypeContracted()).subscribe(
        res => {
          this.usuarioSolicitante = res[0];
          //console.log(this.usuarioSolicitante);

          this.plan = res[0].plan.substring(0, res[0].plan.indexOf('-', 0)).trim().toUpperCase();
          //console.log(_plan);

          this.mostrarMensajeBono();


        },
        err => {
          console.log(err);
        }
        )


    }

  }

  public changedCiudad(e: any): void {
    this.ciudadSeleccionada = e.value;
    this.ciudadSeleccionadaTexto = e.data[0].text;

    this.mostrarMensajeBono();
  }

  private mostrarMensajeBono(): void {

    //1: Bogota
    if (this.ciudadSeleccionada === '1' && this.plan != '') {
      if (!(this.plan === 'L' || this.plan === 'E' || this.plan === 'W' || this.plan === 'T' || this.plan === 'ES')) {
        this.toastr.info('<p>En nuestros centros médicos propios de ' + this.ciudadSeleccionadaTexto + ': Chicó, Palermo, Santa Mónica y 125. El bono tiene una tarifa preferencial.</p>', 'Recuerda:', {
          tapToDismiss: false,
          enableHtml: true,
          timeOut: 0,
          closeButton: true,
          positionClass: 'toast-bottom-full-width'
        });
      }
    }

    //3: Medellin
    //12: Villavicencio
    //16: Ibague
    if ((this.ciudadSeleccionada === '3' || this.ciudadSeleccionada === '12' || this.ciudadSeleccionada === '16') && this.plan != '') {
      if (!(this.plan === 'L' || this.plan === 'E' || this.plan === 'W' || this.plan === 'T' || this.plan === 'ES')) {
        this.toastr.info('<p>En nuestros centros médicos propios de ' + this.ciudadSeleccionadaTexto + '. El bono tiene una tarifa preferencial.</p>', 'Recuerda:', {
          tapToDismiss: false,
          enableHtml: true,
          timeOut: 0,
          closeButton: true,
          positionClass: 'toast-bottom-full-width'
        });
      }
    }
  }

  public changedAutorizacionAutomatica(e: any): void {
    this.autorizacionAutomaticaSeleccionada = e.value;
    this.autorizacionAutomaticaSeleccionadaTexto = e.data[0].text;

    this.cleanSolicitud();

    if (this.autorizacionAutomaticaSeleccionada !== '-1' && this.autorizacionAutomaticaSeleccionada !== '' && this.autorizacionAutomaticaSeleccionada !== '6') {

      this.citasDisponibles30Dias = false;
      //validar si existen citas ultimos 30 dias

      let _carnet = '';
      let _beneficiarios = this.beneficiariosContrato;

      for (let b of _beneficiarios) {
        if (b.documentId.trim() === this.identificacionSolicitante.trim()) {
          _carnet = b.carne;
          break;
        }
      }

      if (_carnet !== '') {

        this._appointmentService.getAppointment30days(this.usuarioSolicitante.documentType, this.identificacionSolicitante, _carnet).subscribe(
          res => {

            //console.log(res.length);
            if (res.length > 0) {

              this.citasDisponibles30Dias = true;

              let _dataContract = this._sessionService.getDataContract();

              let _codPlan = _dataContract.plan.substring(0, _dataContract.plan.indexOf('-', 0)).trim().toUpperCase();

              this.ipss = undefined;//clear content
              this.examenPlanIps = undefined;

              this.showSpinnerIpss = true;

              this._ipssService.getIpssPlan(_codPlan, this.autorizacionAutomaticaSeleccionada, this.ciudadSeleccionada).subscribe(
                res => {

                  let _array = [];

                  for (let r of res) {
                    let _obj = {
                      id: r.codigoIPS,
                      text: r.nombre
                    };
                    _array.push(_obj);
                  }

                  let _optionDefault = this.getOptionDefault('Seleccione una opción...');
                  let _optionIpss = _array;
                  let _options = _optionDefault.concat(_optionIpss);

                  this.showSpinnerIpss = false;
                  this.ipss = _options;

                },
                err => {
                  this.showSpinnerIpss = false;
                  console.log(err);
                }
              )

            } else {
              swal({
                title: 'Citas Médicas',
                padding: 20,
                html: '<p style="font-size:14px; text-align: justify">No tiene una cita médica asignada en los últimos 60 días.<br/>Seleccione la opción <b>OTROS</b> en autorización automática para radicar la solicitud de autorización</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
            }
          },
          err => {
            console.log(err);
          }
        )

      } else {
        console.log('El número de carnet del beneficiario seleccionado es nulo.');
      }

    }

    if (this.autorizacionAutomaticaSeleccionada !== '-1' && this.autorizacionAutomaticaSeleccionada !== '' && this.autorizacionAutomaticaSeleccionada === '6') {
      this.getClasificarSolicitud();
    }

  }

  getClasificarSolicitud() {
    this.showSpinnerClasificarSolicitud = true;
    this._listService.getList({ tipoConsulta: TipoConsulta.ClasificarSolicitud }).subscribe(
      res => {

        let _optionDefault = this.getOptionDefault('Seleccione una opción...');
        let _optionClasificarSolicitud = res;
        let _options = _optionDefault.concat(_optionClasificarSolicitud);
        this.showSpinnerClasificarSolicitud = false;
        this.clasificarSolicitud = _options;
      },
      err => {
        this.showSpinnerClasificarSolicitud = false;
        console.log(err);
      }
    )
  }

  irHomeAutorizaciones() {
    this.router.navigate(['/office/authorization/home']);
  }

  irSolicitaAutorizacion() {
    this.removeClass();
    jQuery("#stepSolicitaAutorizacion").addClass("active");
    jQuery("#tabSolicitaAutorizacion").addClass("active");
  }

  irTipoAutorizacion() {

    if (this.selectedBeneficiario == '-1' || this.selectedBeneficiario == '') {
      swal({
        title: 'Solicitud Autorización',
        html: '<p style="font-size:14px">Seleccione un solicitante</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.ciudadSeleccionada == '-1' || this.ciudadSeleccionada == '') {
      swal({
        title: 'Solicitud Autorización',
        html: '<p style="font-size:14px">Seleccione una ciudad</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.autorizacionAutomaticaSeleccionada == '-1' || this.autorizacionAutomaticaSeleccionada == '') {
      swal({
        title: 'Solicitud Autorización',
        html: '<p style="font-size:14px">Seleccione una autorización automática</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (!this.citasDisponibles30Dias && this.autorizacionAutomaticaSeleccionada != '6') {
      swal({
        title: 'Citas Médicas',
        padding: 20,
        html: '<p style="font-size:14px; text-align: justify">No tiene una cita médica asignada en los últimos 60 días.<br/>Seleccione la opción <b>OTROS</b> en autorización automática para radicar la solicitud de autorización</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    this.removeClass();
    jQuery("#stepTipoAutorizacion").addClass("active");
    jQuery("#tabTipoAutorizacion").addClass("active");


  }

  public changedIpss(e: any): void {
    this.ipssSeleccionada = e.value;
    this.ipssSeleccionadaTexto = e.data[0].text;

    this.examenPlanIps = undefined;

    if (this.ipssSeleccionada !== '-1' && this.ipssSeleccionada !== '') {

      let _dataContract = this._sessionService.getDataContract();

      let _codPlan = _dataContract.plan.substring(0, _dataContract.plan.indexOf('-', 0)).trim().toUpperCase();

      this.showSpinnerExamenPlanIps = true;

      this._examenService.getExamenPlanIps(_codPlan, this.autorizacionAutomaticaSeleccionada, this.ipssSeleccionada, this._sessionService.getSelectContract()).subscribe(
        res => {
          //console.log(res);
          this.showSpinnerExamenPlanIps = false;
          for (let r of res) {
            r.checked = false;
            r.valueBilateral = '-1';
            r.textoBilateral = '';
          }
          this.examenPlanIps = res;
        },
        err => {
          this.showSpinnerExamenPlanIps = false;
          console.log(err);
        }
      )



    }

  }

  public changedBilateridad(e: any): void {
    this.bilateridadSeleccionada = e.value;
  }

  public changedClasificarSolicitud(e: any): void {
    this.clasificarSolicitudSeleccionada = e.value;
    this.clasificarSolicitudSeleccionadaTexto = e.data[0].text;
  }

  removeClass() {
    jQuery("ul.nav-tabs li").removeClass("active");
    jQuery("div.tab-pane").removeClass("active");
  }

  refreshFilesUpload(files) {
    this.files = files;
    //console.log(files);    
  }

  radicarSolicitud() {
    //radicar solicitud de autorización
    this.valueAutorizacionAutomatica = '6';
    this.autorizacionAutomaticaSeleccionada = '6';
    this.getClasificarSolicitud();
    this.irTipoAutorizacion();
  }

  confirmarSolicitud() {

    if (this.autorizacionAutomaticaSeleccionada === '-1' || this.autorizacionAutomaticaSeleccionada === '') {
      swal({
        title: 'Confirmar Solicitud',
        html: '<p style="font-size:14px">No existe una solicitud en curso para confirmar</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.autorizacionAutomaticaSeleccionada !== '6') {

      if (this.ipssSeleccionada === '-1' || this.ipssSeleccionada === '') {
        swal({
          title: 'IPS',
          html: '<p style="font-size:14px">Seleccione la IPS donde desea tomarse el exámen</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
        return;
      }

      let _examenes = this.examenPlanIps;
      let _countSelectExamen = 0;

      //valida seleccion examen
      for (let e of _examenes) {
        if (e.checked) {
          _countSelectExamen++;
        }
      }

      if (_countSelectExamen === 0) {
        swal({
          title: 'Examenes',
          html: '<p style="font-size:14px">Seleccione los exámenes a autorizar</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
        return;
      }

      //valida seleccion bilateridad si aplica      

      for (let e of _examenes) {
        if (e.checked) {
          if (e.bilateral === 1) {
            if (e.valueBilateral === '-1' || e.valueBilateral === '') {
              swal({
                width: 500,
                title: 'Latelaridad Examen',
                html: `<p style="font-size:14px">Seleccione la latelaridad del exámen <b>${e.descripcion} - ${e.nombre}</b></p>`,
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
              return;
            }
          }
        }
      }

      if (this.autorizacionAutomaticaSeleccionada === '2' || this.autorizacionAutomaticaSeleccionada === '3'
        || this.autorizacionAutomaticaSeleccionada === '4' || this.autorizacionAutomaticaSeleccionada === '7') {
        if (_countSelectExamen !== 1) {
          swal({
            width: 500,
            title: 'Autorización Automática',
            html: `<p style="font-size:14px">Para la autorización automática <b>${this.autorizacionAutomaticaSeleccionadaTexto}</b> por favor seleccionar un solo exámen</p>`,
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
          return;
        }
      }

      //mostrar seccion de confirmación.
    } else {//Solicitud Radicada

      if (this.clasificarSolicitudSeleccionada === '-1' || this.clasificarSolicitudSeleccionada === '') {
        swal({
          title: 'Clasificar Solicitud',
          html: '<p style="font-size:14px">Debe clasificar la solicitud</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
        return;
      }

      if (this.files === undefined || this.files.length === 0) {

        swal({
          title: 'Adjuntos Solicitud',
          html: '<p style="font-size:14px">No ha adjuntado ningun archivo a esta solicitud</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false,
        });
        return;

      }
      /*
      let _obs = this.obsClasificarSolicitud.trim();

      if(_obs === ''){

        swal({
          title: 'Observación Solicitud',
          html: '<p style="font-size:14px">No ha ingresado una observación para esta solicitud</p>',
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
        return;

      }
      */

    }

    this.removeClass();
    jQuery("#stepConfirmaSolicitud").addClass("active");
    jQuery("#tabConfirmaSolicitud").addClass("active");


  }

  public changedBilateridadExamenPlanIps(e: any, descripcion: string): void {
    //console.log(e);
    //console.log(descripcion);

    let _examenes = this.examenPlanIps;

    for (let examen of _examenes) {
      if (examen.descripcion === descripcion) {
        examen.valueBilateral = e.value;
        examen.textoBilateral = e.data[0].text;
        break;
      }
    }
    //console.log(this.examenPlanIps);
  }

  generarSolicitudManual() {


    var data = new FormData();

    var _files = this.files;

    //agrego adjuntos
    for (var i = 0; i < _files.length; i++) {
      data.append("file" + (i + 1), _files[i]);
      //console.log(_files[i]);
    }

    let _userCurrent = this._sessionService.getCurrentUser();

    data.append("idUserSettled", _userCurrent.documentId);
    data.append("settledName", _userCurrent.name);
    data.append("idUserRequest", this.usuarioSolicitante.documentId);
    data.append("requestName", this.usuarioSolicitante.name);
    data.append("requestSurName", this.usuarioSolicitante.surName);
    data.append("mobilePhone", this.usuarioSolicitante.celphone);
    data.append("email", this.usuarioSolicitante.email);
    data.append("requestEmail", this.usuarioSolicitante.email);
    data.append("contract", this._sessionService.getSelectContract());
    data.append("contractState", this.usuarioSolicitante.state);
    data.append("matrizNumber", this.usuarioSolicitante.matrizNumber);
    data.append("matrizName", this.usuarioSolicitante.matrizName);
    data.append("documentType", this.usuarioSolicitante.documentType);
    data.append("contractType", this.usuarioSolicitante.contractType);
    data.append("plan", this.usuarioSolicitante.plan);
    data.append("settledDate", "");
    data.append("idCity", this.ciudadSeleccionada);
    //console.log("clasificarSolicitudSeleccionada: " + this.clasificarSolicitudSeleccionada)
    data.append("idRequestType", "1");
    data.append("requestObservation", this.obsClasificarSolicitud.trim());
    data.append("requestState", "1");

    this.showSpinnerManual = true;


    this._authorizationService.postCreaAutorizacionManual(data).subscribe(
      res => {
        //console.log(res);
        this.showSpinnerManual = false;
        swal({
          width: 600,
          allowOutsideClick: false,
          title: 'Respuesta Solicitud',
          html: `<div style="font-size: 14px">Su solicitud de autorización No. "${res.id}" se encuentra en trámite.<br>Recibirá un correo del área encargada.</div>`,
          type: res.type,
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/office/authorization/home']);
          }
        });
      },
      err => {
        this.showSpinnerManual = false;
        if (err.status === 406) {
          swal({
            width: 500,
            title: 'Autorización Manual',
            html: `<p style="font-size:14px">${err.error.message}</p>`,
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

        } else {
          swal({
            width: 500,
            title: 'Autorización Manual',
            html: `<p style="font-size:14px">Ha ocurrido un error con esta solicitud. Por favor vuelva a intentarlo</p>`,
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        }
      }
    )

  }

  generarSolicitudAutomatica() {

    let _examenes = [];

    for (let e of this.examenPlanIps) {
      if (e.checked) {

        let _obj = {
          idTicketAutomaticaExamen: 0,
          idTicket: '',
          area: e.area,
          concepto: e.concepto,
          descripcion: e.descripcion.trim() + '|' + (e.bilateral === 1 ? e.textoBilateral : ''),
          nombre: e.nombre,
          fecha: ''
        };
        _examenes.push(_obj);

      }

    }


    let _userCurrent = this._sessionService.getCurrentUser();


    let _objAutorizacion = {
      idUserSettled: _userCurrent.documentId,
      settledName: _userCurrent.name,
      contract: this._sessionService.getSelectContract(),
      idUserRequest: this.usuarioSolicitante.documentId,
      requestName: this.usuarioSolicitante.name,
      requestSurName: this.usuarioSolicitante.surName,
      mobilePhone: this.usuarioSolicitante.celphone,
      email: this.usuarioSolicitante.email,
      contractState: this.usuarioSolicitante.state,
      matrizNumber: this.usuarioSolicitante.matrizNumber,
      matrizName: this.usuarioSolicitante.matrizName,
      documentType: this.usuarioSolicitante.documentType,
      contractType: this.usuarioSolicitante.contractType,
      plan: this.usuarioSolicitante.plan,
      idCity: this.ciudadSeleccionada,
      idArea: this.autorizacionAutomaticaSeleccionada,
      requestObservation: '',
      requestState: '1'
    }

    let _objAutomatic = {
      idAutorizacionAutomatica: this.autorizacionAutomaticaSeleccionada,
      codigoIps: this.ipssSeleccionada,
      nombreIps: this.ipssSeleccionadaTexto,
      lsExamenes: _examenes
    }

    this.showSpinnerAutomatico = true;
    let _html = '';
    let _titulo = '';

    this._authorizationService.postCreaAutorizacionAutomatica(this.ipssSeleccionada, this.identificacionSolicitante, this.usuarioSolicitante.documentType, _objAutorizacion, _objAutomatic).subscribe(
      res => {

        //console.log(res.id);
        this._voucherAttached.getVoucherAttached(res.id, 2).subscribe(
          resAttached => {
            let _vouchers = resAttached;

            if (_vouchers.length > 0) {

              _titulo = `Autorización Exitosa`;

              _html += `<ul><li style="font-size: 14px">Descargue el archivo PDF</li>`
              _html += `<li style="font-size: 14px; font-color:red">Imprimalo</li>`
              _html += `<li style="font-size: 14px">Presentelo al prestador médico el día de su cita</li></ul></b><br/><br/>`;

              _html += `
                    <table id="tableSoportesAdjuntos" class="table table-bordered primary" cellspacing="0" width="100%">
                    <thead>
                      <tr style="background-color: #0054a5; color: #ffff; text-align: center;">
                        <th>Nombre archivo</th>
                        <th>Fecha</th>
                        <th>Descargar</th>
                      </tr>
                    </thead>
                    <tbody>`;

              let _i = 1;

              for (let v of _vouchers) {
                _html += `
                        <tr>
                        <td><span id="filename${_i}">${v.fileName}</span><input id="file${_i}" type="hidden" value="${v.file}"/></td> 
                        <td>${v.attachedDate}</td>
                        <td><button id="btn${_i}" type="button" class="btn btn-xs btn-default btnDescarga" title="Descarga Adjunto"><img id="img${_i}" src="./assets/images/${IconoUtility.getNameIconoType(v.fileName)}.png" width="35"/></button></td>
                        </tr>
                      `;
                _i++;
              }

              _html += `</tbody>
                    </table>
                    <span id="message" style="font-type: 18px; font-weight: bold"></span><br/>`;
            }
            else {
              _titulo = `Solicitud de Autorización`;
            }
            this.showSpinnerAutomatico = false;
            swal({
              width: 800,
              padding: 25,
              allowOutsideClick: false,
              title: _titulo,
              html: '<div style="text-align: justify; margin-top: 20px">' + _html + res.message + '</div>',
              //type: res.type,
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false,
              onOpen: () => {
                jQuery("#message").text("");
                jQuery("#tableSoportesAdjuntos").addClass("tableSoportesAdjuntos");
                jQuery(".btnDescarga").click((result) => {
                  var _id = '';
                  _id = result.target.id;
                  _id = _id.substring(3, _id.length);
                  var _idfilename = 'filename' + _id;
                  var _idfile = 'file' + _id;
                  var _filename = jQuery("#" + _idfilename).text();
                  var _file = jQuery("#" + _idfile).val();

                  var xhr = new XMLHttpRequest();
                  xhr.open('GET', this._apiConfig.url + '/vouchers/download/6?name=' + _file, true);
                  xhr.setRequestHeader('Authorization', 'Bearer ' + this._sessionService.getToken());
                  xhr.responseType = 'blob';

                  xhr.onload = function (e) {
                    if (xhr.status == 200) {
                      var blob = new Blob([xhr.response], { type: 'application/octet-stream' });
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = _filename;
                      link.click();
                      jQuery("#message").css("color", "green");
                      jQuery("#message").text("Se ha descargado: " + _filename);
                    } else {
                      jQuery("#message").css("color", "red");
                      jQuery("#message").text("Ocurrio un error al descargar: " + _filename);
                    }
                  };

                  xhr.send();
                });
              }
            }).then((result) => {
              if (result.value) {
                this.router.navigate(['/office/authorization/home']);
              }
            });
          },
          err => {
            this.showSpinnerAutomatico = false;
            if (err.status === 406) {
              swal({
                width: 500,
                title: 'Autorización Automática',
                html: `<p style="font-size:14px">${err.error.message}</p>`,
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });

            } else {

              swal({
                width: 500,
                title: 'Autorización Automática',
                html: `<p style="font-size:14px">Ha ocurrido un error con esta solicitud. Por favor vuelva a intentarlo</p>`,
                type: 'error',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });

            }

          }
        );

      },
      err => {
        this.showSpinnerAutomatico = false;
        if (err.status === 406) {
          swal({
            width: 500,
            title: 'Autorización Automática',
            html: `<p style="font-size:14px">${err.error.message}</p>`,
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

        } else {

          swal({
            width: 500,
            title: 'Autorización Automática',
            html: `<p style="font-size:14px">Ha ocurrido un error con esta solicitud. Por favor vuelva a intentarlo</p>`,
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

        }

      }
    )
  }

  validarUnSoloExamen(bchecked) {

    let _examenes = this.examenPlanIps;
    let _countSelectExamen = 0;

    //valida seleccion examen
    for (let e of _examenes) {
      if (e.checked) {
        _countSelectExamen++;
      }
    }

    if (bchecked) {
      _countSelectExamen--;
    } else {
      _countSelectExamen++;
    }

    if (this.autorizacionAutomaticaSeleccionada === '2' || this.autorizacionAutomaticaSeleccionada === '3'
      || this.autorizacionAutomaticaSeleccionada === '4' || this.autorizacionAutomaticaSeleccionada === '7') {
      if (_countSelectExamen !== 1 && _countSelectExamen !== 0) {
        swal({
          width: 500,
          title: 'Autorización Automática',
          html: `<p style="font-size:14px">Para la autorización automática <b>${this.autorizacionAutomaticaSeleccionadaTexto}</b>, por favor seleccionar un solo exámen</p>`,
          type: 'warning',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });

        for (let e of _examenes) {
          e.checked = false;
        }
      }
    }

  }

  infoCiudadProcedimiento() {

    let _message = `
        <div style="padding: 5px">
          <p>Seleccione la ciudad en la cual desea hacerse el procedimiento.</p>
        </div>    
        `;

    this.toastr.info(_message, 'Ciudad de procedimiento:', {
      tapToDismiss: false,
      enableHtml: true,
      timeOut: 0,
      closeButton: true,
      positionClass: 'toast-bottom-full-width'
    });

  }

  infoTipoAutorizacion() {

    let _message = `
            <div style="padding: 5px">
              <p>Si no encuentra en el listado el tipo de autorización a solicitar, puede seleccionar la opción OTROS.</p>
            </div>    
            `;

    this.toastr.info(_message, 'Tipo de Autorización:', {
      tapToDismiss: false,
      enableHtml: true,
      timeOut: 0,
      closeButton: true,
      positionClass: 'toast-bottom-full-width'
    });

  }

  cleanSolicitud() {

    this.ipssSeleccionada = '-1';
    this.clasificarSolicitudSeleccionada = '-1';
    this.files = undefined;
    this.obsClasificarSolicitud = '';
    if (this.examenPlanIps !== undefined && this.examenPlanIps !== null) {
      for (let e of this.examenPlanIps) {
        e.checked = false;
      }
    }

  }

}



// WEBPACK FOOTER //
// /app/src/app/office/authorization/request-authorization/request-authorization.component.ts